import React, { FC } from 'react';
import classNames from 'classnames';
import { LinkedWrapperProps } from 'atomic/linked-wrapper/linked-wrapper.interface';

import './linked-wrapper.scss';

const LinkedWrapper: FC<LinkedWrapperProps> = ({
    title,
    children,
    href,
    className,
    target,
    rel
}) => {
    return (
        <div
            className={classNames('linked-wrapper', className)}
        >
            <a
                title={title}
                href={href}
                target={target}
                rel={rel}
            >
                {children}
            </a>
        </div>
    );
};

export default LinkedWrapper;
